import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon } from 'lucide-react';
const offerings = [{
  title: 'NUTRISIB Club – Metoda C.E.L.O.S.',
  subtitle: 'Program complet de 6 luni, în grup sau 1:1 Premium',
  desc: 'Aceeași metodă C.E.L.O.S., aplicată pe durata a 6 luni, prin cele 4 faze (Calibrare, Energie, Longevitate, Optimizare Sistemică). Alegi între varianta Standard, cu suport la nivel de grup, sau Premium, cu sesiuni individuale 1:1 alături de comunitate.',
  benefits: ['Același sistem C.E.L.O.S. structurat pe 6 luni și 4 faze', 'Audit inițial complet: scanare BIA și biorezonanță cu dashboard biologic personal', 'Plan nutrițional și protocol de suplimentare construite pe baza datelor tale, nu pe liste generice', 'Comunitate activă de profesioniști care trec prin același proces', 'Două variante la alegere: Standard (suport de grup) sau Premium (grup plus sesiuni 1:1 lunare)', 'Verificarea compatibilității cu medicația actuală și ajustări periodice'],
  cta: 'Vreau să intru în NUTRISIB Club',
  link: 'https://nutrisib.club/celos',
  img: 'https://cdn.magicpatterns.com/uploads/otTEcJLn1iutvx6vPzfRR3/Screenshot_2026-04-22_at_13.38.42.png'
}, {
  title: 'Evaluare Personalizată Avansată C.E.L.O.S.',
  subtitle: 'Sesiune Individuală pentru Interpretarea Parametrilor Biologici',
  desc: 'Prima imagine obiectivă a sistemului tău biologic. O sesiune individuală în care scanăm corpul tău, analizăm datele și construim împreună prima hartă de parcurs, fără obligația de a continua mai departe.',
  benefits: ['Scanare BIA cu peste 20 de parametri măsurați (compoziție corporală, masă musculară, grăsime viscerală, hidratare)', 'Scanare biorezonanță pentru starea funcțională a corpului tău (stres, inflamație, echilibre interne)', 'Dashboard biologic personal cu rezultatele tale interpretate clar, fără jargon tehnic', 'Identificarea celor 1-2 blocaje principale care îți sabotează energia, greutatea sau claritatea mentală', 'Primele recomandări practice pe care le poți aplica imediat', 'Disponibil fizic în Sibiu sau complet online pe Zoom'],
  cta: 'Programează Evaluarea Avansată',
  link: 'https://nutrisib.club/evaluare',
  img: 'https://cdn.magicpatterns.com/uploads/otTEcJLn1iutvx6vPzfRR3/Screenshot_2026-04-22_at_13.38.42.png'
}];
export function Offerings() {
  return <section className="bg-navy py-16 lg:py-20" data-id="element-202">
      <div className="max-w-7xl mx-auto px-6 lg:px-8" data-id="element-203">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-16" data-id="element-204">
          <h2 className="text-3xl md:text-4xl font-montserrat font-bold text-pearl mb-4" data-id="element-205">
            Alege formatul potrivit pentru tine
          </h2>
          <p className="font-lora text-lg text-pearl/80 max-w-2xl mx-auto" data-id="element-206">
            Două căi prin care poți lucra cu mine, în funcție de unde te afli și
            ce îți dorești. Aceeași metodă C.E.L.O.S., aplicată în grup sau
            individual premium.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12" data-id="element-207">
          {offerings.map((offer, idx) => <motion.div key={idx} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: idx * 0.2
        }} className="flex flex-col h-full" data-id="element-208">
              {/* Top Image Area */}
              <div className="w-full h-48 rounded-t-lg overflow-hidden border-t-2 border-l-2 border-r-2 border-gold" data-id="element-209">
                <img src={offer.img} alt={offer.title} className="w-full h-full object-cover object-center" data-id="element-210" />
              </div>

              {/* Content Area with Gold Border */}
              <div className="flex-1 bg-white rounded-b-lg border-b-2 border-l-2 border-r-2 border-gold p-8 md:p-10 flex flex-col" data-id="element-211">
                <h3 className="font-montserrat font-bold text-navy text-2xl mb-2 text-center md:text-left" data-id="element-212">
                  {offer.title}
                </h3>
                <p className="font-inter text-[17px] font-semibold text-gold uppercase tracking-wide mb-6 text-center md:text-left" data-id="element-213">
                  {offer.subtitle}
                </p>
                <p className="font-inter text-[18px] text-text-medium leading-relaxed mb-8" data-id="element-214">
                  {offer.desc}
                </p>

                <ul className="space-y-3.5 mb-10 flex-1" data-id="element-215">
                  {offer.benefits.map((benefit, bIdx) => <li key={bIdx} className="flex items-start gap-3" data-id="element-216">
                      <div className="w-5 h-5 rounded-full bg-gold/10 flex items-center justify-center mt-0.5 flex-shrink-0" data-id="element-217">
                        <CheckIcon className="w-3 h-3 text-gold" strokeWidth={3} data-id="element-218" />
                      </div>
                      <span className="font-inter text-[18px] text-text-dark leading-relaxed" data-id="element-219">
                        {benefit}
                      </span>
                    </li>)}
                </ul>

                <a href={offer.link} className="w-full bg-gold text-navy font-inter font-bold uppercase tracking-wide px-6 py-4 rounded-md hover:-translate-y-0.5 hover:shadow-lg transition-all duration-200 block text-center no-underline" data-id="element-220">
                  {offer.cta}
                </a>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}